module.exports = __webpack_public_path__ + "static/img/fdmServer1.2d654a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdmServer1.png
// module id = sGic
// module chunks = 2